// Module
var code = `<template>
  <a class="grid-icon" href.bind="url">
    <mdc-icon if.bind="boolValue" aria-hidden="true" class="mdc-theme--primary">check</mdc-icon>
    <mdc-icon if.bind="!boolValue" aria-hidden="true" style="color:#684e4a">remove</mdc-icon>
  </a>
</template>
`;
// Exports
export default code;